import Controller, { OnMount } from '@philips-internal/oswald-ui-core/lib/client';

import BaseController from '../../BaseController';
import InformationBarUtils from '../../commons/header/information-bar-header-utils';

import './pep-security-alert-controller.css';

@Controller({ component: 'pep-security-alert-layout', fragment: 'pep-security-alert' })
class PepSecurityAlertController extends BaseController {

  @OnMount({ target: 'pep-security-alert-layout' })
  onMount(): void {
    InformationBarUtils.collapsedBar = true;

    const { patientId, encounterId } = this.historyService.getCurrentRouteParams();
    const pepNumberFunction = 281;

    this.context.set({
      alertPersonCode: patientId,
      encounterId,
      encounterNumber: encounterId,
      functionCode: pepNumberFunction,
      patientId,
    })
  }
}

export default PepSecurityAlertController;
